import * as Yup from 'yup'

import { NOTIFICATION_TYPE } from '../../../constants/common'
import { DocFlowRequestLinksField } from '../../../constants/docFlow'
import { NOTIFICATION_FILE_UPLOAD_LIMIT } from '../../../constants/notification'
import { SERVER_NON_FIELD_ERROR_KEY } from '../../../constants/validation'
import i18n from '../../../i18n'
import { getItemsIds } from '../../../utils/common'
import { getDocFlowRequestLinksErrorText } from '../../../utils/docFlow'
import { parseServerValidation } from '../../../utils/validation'
import {
  DOC_FLOW_FORM_FIELD_CONNECTED_REQUESTS,
  DOC_FLOW_FORM_FIELD_FILES,
  DOC_FLOW_FORM_FIELD_FINAL_DOCUMENT_TITLE,
  DOC_FLOW_FORM_FIELD_TITLE,
  DOC_FLOW_FORM_FINAL_NAME_FIELD_MAX_LENGTH,
  DOC_FLOW_FORM_TITLE_FIELD_MAX_LENGTH,
  DOC_FLOW_PHASE_WARNING_SCANNED_NOTIFICATION_SPLITTING,
} from '../DocFlow.constants'
import { getDocFlowBuildingScopePayload } from '../DocFlow.utils.scope'
import { DOC_FLOW_WIDGETS_SPLITTING_MAPPING_PERMANENT_NOTIFICATION_ID } from '../DocFlowWidgets'

export function getDocFlowFormCreationPayload({ files, values }) {
  const payload = {
    ...getDocFlowBuildingScopePayload(values),
    [DOC_FLOW_FORM_FIELD_FINAL_DOCUMENT_TITLE]:
      values[DOC_FLOW_FORM_FIELD_FINAL_DOCUMENT_TITLE],
    [DOC_FLOW_FORM_FIELD_TITLE]: values[DOC_FLOW_FORM_FIELD_TITLE],
  }

  if (files.length > 0) {
    payload[DOC_FLOW_FORM_FIELD_FILES] = getItemsIds(files)
  }

  const connectedRequests = values[DOC_FLOW_FORM_FIELD_CONNECTED_REQUESTS]

  if (connectedRequests.length > 0) {
    payload[DocFlowRequestLinksField.DocFlowRequestIds] = getItemsIds(
      connectedRequests,
      'value'
    )
  }

  return payload
}

export function getDocFlowFormServerErrors({ data, t, values }) {
  const requestLinksErrorText = getDocFlowRequestLinksErrorText({
    connectedRequests: values[DOC_FLOW_FORM_FIELD_CONNECTED_REQUESTS],
    data,
    t,
  })

  return requestLinksErrorText
    ? { [SERVER_NON_FIELD_ERROR_KEY]: requestLinksErrorText }
    : parseServerValidation(data)
}

export function getValidationSchema() {
  return Yup.object({
    [DOC_FLOW_FORM_FIELD_FINAL_DOCUMENT_TITLE]: Yup.string()
      .max(
        DOC_FLOW_FORM_FINAL_NAME_FIELD_MAX_LENGTH,
        i18n.t('Error.MaxLengthKey', {
          length: DOC_FLOW_FORM_FINAL_NAME_FIELD_MAX_LENGTH,
        })
      )
      .required(() => true),
    [DOC_FLOW_FORM_FIELD_TITLE]: Yup.string()
      .max(
        DOC_FLOW_FORM_TITLE_FIELD_MAX_LENGTH,
        i18n.t('Error.MaxLengthKey', {
          length: DOC_FLOW_FORM_TITLE_FIELD_MAX_LENGTH,
        })
      )
      .required(() => true),
  })
}

export function getInitialNotifications() {
  return [
    {
      id: NOTIFICATION_FILE_UPLOAD_LIMIT,
      text: i18n.t('Form.UploadFilesCountLimitErrorKey'),
      type: NOTIFICATION_TYPE.info,
    },
    {
      id: DOC_FLOW_WIDGETS_SPLITTING_MAPPING_PERMANENT_NOTIFICATION_ID,
      text: i18n.t(DOC_FLOW_PHASE_WARNING_SCANNED_NOTIFICATION_SPLITTING.text),
      type: DOC_FLOW_PHASE_WARNING_SCANNED_NOTIFICATION_SPLITTING.type,
    },
  ]
}
